export class CustomError extends Error {
	constructor(messageOrError: string | Error, name: string) {
		const message = messageOrError instanceof Error ? messageOrError.message : messageOrError;
		super(message);
		this.name = name;

		// Copy stack trace if an Error was passed
		if (messageOrError instanceof Error) {
			this.stack = messageOrError.stack;
		}
	}
}

export class SubmitError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'SubmitError');
	}
}

export class EnvVariableError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'EnvVariableError');
	}
}

export class BuilderError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'BuilderError');
	}
}

export class ScriptError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'ScriptError');
	}
}

export class TimeoutError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'TimeoutError');
	}
}

export class FeatheryError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'FeatheryError');
	}
}

export class LandingError extends CustomError {
	constructor(messageOrError: string | Error) {
		super(messageOrError, 'LandingError');
	}
}

export enum GeneralError {
	NoPageFound = 'No page found - 404',
}
